import paper from 'paper';
import { Tool } from 'paper';
import store from '../store';

let local = {
    shape: null,
    selectionRectangle: null,
    selectionRectangleScale: null,
    selectionRectangleScaleNormalized: null,
    selectionRectangleRotation: null
};

var hitOptions = {
    segments: true,
    stroke: true,
    curves: true,
    fill: true,
    guide: false,
    tolerance: 8
};

function onMouseDown(event) {
    local.shape = getHitShape(event);
}

function onMouseMove(event) {
    paper.project.getItems({selected: true})
        .forEach(item => item.selected = false);

    if (event.item && event.item.layer.name == 'selectable'
        && (local.selectionRectangle == null || local.selectionRectangle.ppath !== event.item)
    ){
        event.item.selected = true;
    }
}

async function onMouseUp(event) {
    if (local.shape === null) {
        return;
    }

    let hitShape = getHitShape(event);

    if (hitShape == null || local.shape == null || hitShape.id != local.shape.id) {
        local.shape = null;
        return;
    }

    hitShape.removeItem();
    store.dispatch('removeShapeId', hitShape.id);
}

function getHitShape(event) {
    let hitResults = paper.project.hitTestAll(event.point, hitOptions);

    if (hitResults == null) {
        local.itemId = null;
        return;
    }

    let firstHit = hitResults.find(hitResult => {
        let shape = store.getters.shapes.find(shape => shape.pathId == hitResult.item.id);
        return shape != null && shape.accepts('delete');
    })

    return firstHit ? store.getters.shapes.find(shape => shape.pathId == firstHit.item.id) : null;
}

export const EraserTool = new Tool({
    name: 'eraser',
    onMouseDown,
    onMouseMove,
    onMouseUp,
});
